"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8029],{

/***/ 65509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ FactoryCookie; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50853);
/* harmony import */ var _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24880);




var FactoryCookie = /*#__PURE__*/ function() {
    "use strict";
    function FactoryCookie(config) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, FactoryCookie);
        this.config = config;
    }
    var _proto = FactoryCookie.prototype;
    _proto.cookie = function cookie() {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
            var isNode, _tmp;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isNode = _kernel_Environment__WEBPACK_IMPORTED_MODULE_3__/* .Environment.create */ .q.create().isNode();
                        if (!isNode) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 5107).then(__webpack_require__.t.bind(__webpack_require__, 15107, 23))
                        ];
                    case 1:
                        _tmp = _state.sent().NodeCookie.create({
                            config: _this.config
                        });
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 9351).then(__webpack_require__.bind(__webpack_require__, 39351))
                        ];
                    case 3:
                        _tmp = _state.sent().WindowCookie.create({
                            config: _this.config
                        });
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            _tmp
                        ];
                }
            });
        })();
    };
    FactoryCookie.create = function create(param) {
        var config = param.config;
        return new FactoryCookie(config);
    };
    return FactoryCookie;
}();


/***/ }),

/***/ 97389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PROPERTIES_VISITED_MAX": function() { return /* binding */ PROPERTIES_VISITED_MAX; },
/* harmony export */   "default": function() { return /* binding */ AddByIDLastSeenPropertyUseCase; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90581);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50853);
/* harmony import */ var _kernel_ID__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86275);
/* harmony import */ var _infrastructure_PropertyRepositoryProxy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40708);





var PROPERTIES_VISITED_MAX = 8;
var AddByIDLastSeenPropertyUseCase = /*#__PURE__*/ function() {
    "use strict";
    function AddByIDLastSeenPropertyUseCase(repository) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, AddByIDLastSeenPropertyUseCase);
        this.repository = repository;
    }
    var _proto = AddByIDLastSeenPropertyUseCase.prototype;
    _proto.execute = function execute(param) {
        var id = param.id;
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
            var currentIDs, nextIDs, savedIDs;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _this.repository.lastSeenIDs()
                        ];
                    case 1:
                        currentIDs = _state.sent();
                        nextIDs = currentIDs.addOne({
                            id: _kernel_ID__WEBPACK_IMPORTED_MODULE_0__.ID.fromNumber({
                                value: id
                            }),
                            limit: PROPERTIES_VISITED_MAX
                        });
                        return [
                            4,
                            _this.repository.saveLastSeenIDs({
                                ids: nextIDs
                            })
                        ];
                    case 2:
                        savedIDs = _state.sent();
                        return [
                            2,
                            savedIDs
                        ];
                }
            });
        })();
    };
    AddByIDLastSeenPropertyUseCase.create = function create(param) {
        var config = param.config, repository = param.repository;
        return new AddByIDLastSeenPropertyUseCase(repository !== null && repository !== void 0 ? repository : _infrastructure_PropertyRepositoryProxy__WEBPACK_IMPORTED_MODULE_1__/* .PropertyRepositoryProxy.create */ .Z.create({
            config: config
        }));
    };
    return AddByIDLastSeenPropertyUseCase;
}();
AddByIDLastSeenPropertyUseCase.USE_CASE_NAME = "AddByIDLastSeenPropertyUseCase";



/***/ })

}]);